import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../components/button";
import PageTitle from "../../components/pageTitle";
import { StoreState } from "../../redux/reduxTypes";
import { ExtratoRepasseExternoV2State } from "../../types/state.types";
import {
  AreaCooperado,
  AreaData,
  AreaInfo,
  ColunasDescricao,
  ColunasImpostos,
  ColunasLiquido,
  ColunasTotal,
  ContainerPagina,
  DiscriminacaoVerba,
  InfoCooperativa,
  LinhaObservacoes,
  LinhasTabela,
  TabelaConteudo
} from "./styled";

import { getSessionConfig } from "../../utils/session-helper";
import { formatData, formatMoney } from "../../utils/functions-helper";
import IndicadorSemDados from "../../components/indicadorSemDados";
import { useNavigate } from "react-router-dom";
import routes from "../../routes/routes.path";

function ExtratoRepasseExternoV2Impressao() {
  const {
    dadosExtrato,
  } = useSelector<StoreState, ExtratoRepasseExternoV2State>(state => state.extratoRepasseExternoV2State);
  const navigate = useNavigate();

  const [ totalProventos, settotalProventos ] = useState(0);
  const [ totalDescontos, settotalDescontos ] = useState(0);
  const [cooperativaSessionData] = useState(getSessionConfig());

  useEffect(() => {
    if(dadosExtrato && dadosExtrato.length > 0) {
      let proventos = 0;
      let descontos = 0;
      dadosExtrato?.forEach(extrato => {
        switch (extrato.TipoverbaID) {
          case 1:
            proventos += extrato.ValorProvento;
            break;
          case 2:
            descontos += extrato.ValorDesconto;
            break;
          default:
            break;
        }
      })
      settotalProventos(proventos);
      settotalDescontos(descontos);
    }
  }, [dadosExtrato]);

  const irParaRelatorio = useCallback(() => {
    navigate(routes.ExtratoRepasseExternoV2);
  }, [navigate]);

  const imprimirPagina = useCallback(() => {
    window.print();
    // irParaRelatorio();
  }, [/* irParaRelatorio */]);

  return (
  <ContainerPagina>
    <PageTitle titulo="Extrato de Repasse Externo" />
 
    <section className="btnGroup">
      <Button primary onClick={imprimirPagina}>Imprimir</Button>
      <Button primary onClick={irParaRelatorio}>Voltar</Button>
    </section>
    
    <div className="tabela">
    {dadosExtrato && dadosExtrato.length > 0 ?
    <TabelaConteudo className="print">
      <tbody>
        <tr>
          <td>
            <header>
              <AreaData>
                <tbody>
                  <tr>
                    <td>
                      {new Date().toLocaleDateString(
                        'pt-Br',
                        {
                          weekday: 'long',
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric',
                        }
                      )}
                    </td>
                  </tr>
                </tbody>
              </AreaData>

              <AreaInfo>
                <tbody>
                  <tr>
                    <td>
                    <img
                      src={"data:image/png;base64, " + cooperativaSessionData.Logo}
                      alt={`Logotipo - ${cooperativaSessionData.Nome?.split(" ")[0]}`}
                    />
                    </td>
                    <td className="containerInfos">
                      <span>
                        <strong>EXTRATO DE REPASSE EXTERNO</strong><br />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </AreaInfo>

              <InfoCooperativa>
                <tbody>
                  <tr>
                    <td>
                      <strong>
                      COOPERATIVA
                      </strong>
                      {cooperativaSessionData.Nome}
                    </td>

                    <td>
                      <strong>
                      CNPJ
                      </strong>
                      {cooperativaSessionData.CNPJ}
                    </td>

                    <td>
                      <strong>
                      ADMISSÃO
                      </strong>
                      {formatData(dadosExtrato[0].DataAdmissao)}
                    </td>
                    
                    <td>
                      <strong>
                      COMPETÊNCIA
                      </strong>
                      {dadosExtrato[0].CompetenciaList}
                    </td>
                  </tr>
                </tbody>
              </InfoCooperativa>

              <AreaCooperado>
                <tbody>
                  <tr>
                    <td>
                      <strong>
                      COOPERADO
                      </strong>
                      {`${dadosExtrato[0].Matricula} - ${dadosExtrato[0].Cooperado}`}
                    </td>

                    <td>
                      <strong>
                      CARGO
                      </strong>
                      {dadosExtrato[0].Cargo}
                    </td>

                    <td>
                      <strong>
                      LOTAÇÃO
                      </strong>
                      {dadosExtrato[0].Contrato.trim()}
                    </td>
                  </tr>
                </tbody>
              </AreaCooperado>

              <DiscriminacaoVerba>
                Discriminacao Das Verbas
              </DiscriminacaoVerba>
            </header>

            <ColunasDescricao>
            <tbody>
              <tr>
                <td>COD.</td>
                <td>DESCRIÇÃO</td>
                <td>REFERÊNCIA</td>
                <td>PROVENTO</td>
                <td>DESCONTO</td>
              </tr>
            </tbody>
            </ColunasDescricao>
            <main>
              <LinhasTabela>
                <tbody>
                    {dadosExtrato ?
                    dadosExtrato.filter((extrato) => {
                      return extrato.TipoverbaID === 1 || extrato.TipoverbaID === 2 || extrato.TipoverbaID === -1
                    }).map((extrato, i) => {
                      return (
                      <tr key={i}>
                        <td>
                          {extrato.VerbaID}
                        </td>

                        <td style={{ textAlign: 'left', paddingLeft: '8px'}}>
                          {extrato.Verba}
                        </td>

                        <td>
                          {extrato.Referencia}
                        </td>

                        <td>
                        {
                        extrato.TipoverbaID && extrato.TipoverbaID === 1
                          ? formatMoney(extrato.ValorProvento)
                          : ''
                        }
                        </td>

                        <td>
                        {
                        extrato.TipoverbaID && extrato.TipoverbaID === 2
                          ? formatMoney(extrato.ValorDesconto)
                          : ''
                        }
                        </td>
                      </tr>
                      )
                    }) : <></>}
                    {[10,11,12,13,14].map(i => <tr key={i}>
                        <td>
                        </td>

                        <td>
                        </td>

                        <td>
                        </td>

                        <td>
                        </td>

                        <td>
                        </td>
                      </tr>)}
                </tbody>
              </LinhasTabela>

              <ColunasTotal>
                <tbody>
                  <tr>
                    <td> </td>
                    <td>
                      TOTAL PROVENTOS
                      <strong>
                      {formatMoney(totalProventos)}
                      </strong>
                    </td>
                    <td>
                      TOTAL DESCONTOS
                      <strong>
                      {formatMoney(totalDescontos)}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </ColunasTotal>

              <ColunasLiquido>
                <tbody>
                  <tr>
                    <td> </td>
                    <td id="valorLiquido">
                      LIQUIDO A RECEBER
                      <strong>
                      {formatMoney(dadosExtrato[0].ValorLiquido)}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </ColunasLiquido>

              <ColunasImpostos>
                <tbody>
                  <tr>
                    <td> </td>
                    <td>
                      BASE DE CALCULO DO INSS
                      <strong>
                      {formatMoney(dadosExtrato[0].BaseCalculoINSS)}
                      </strong>
                    </td>
                    <td>
                      BASE DE CALCULO DO IRRF
                      <strong>
                      {formatMoney(dadosExtrato[0].BaseCalculoIRRF)}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </ColunasImpostos>

              
              <LinhaObservacoes>
                <tbody>
                  <tr>
                    <td>
                      {dadosExtrato[0].Observacao}
                    </td>
                  </tr>
                </tbody>
              </LinhaObservacoes>
            </main>
          </td>
        </tr>
      </tbody>
    </TabelaConteudo>
    : <IndicadorSemDados />
    }
    </div>
  </ContainerPagina>
  );
}

export default ExtratoRepasseExternoV2Impressao;
